import axios from "axios";

import {encryptAES,decryptAES} from './cryptoHelper';
import store from "store/store";
// import store from '.';
let ENDPOINT =  window.location.origin+"/datarouter/data/search"
if(window.location.host.includes('localhost')){
  ENDPOINT="http://localhost:8080/dataService/data/search"
}
// https://dataservice-lnkibq352q-uc.a.run.app

   const state = store.getState();
    let  isSecureApi=window.secureApi;
   axios.interceptors.request.use(
      function (config) {
        if (!isSecureApi || config.ignoreDecryption) {
          return config; // Skip decryption
        }

        if (encryptAES && config.data) {
          delete config.data.elasticQueryName;
          config.data = encryptAES(config.data);
           config.headers["Content-Type"] = "application/json; charset=UTF-8";
        config.responseType = "text";
        }
       
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        const config = response.config;
        if (!isSecureApi || config.ignoreDecryption) {
          return response; // Skip decryption
        }

        try {
       
          const raw = response?.data;
          const decrypted = decryptAES(raw);
          return { ...response, data: decrypted };
          
        
        } catch (e) {
          console.error("Decryption error:", e);
          return { ...response, data: null };
        }
      },
      function (error) {
        console.error("Axios error:", error);
        return Promise.reject(error);
      }
    );
export default {
  getMethod: () =>
    axios({
      method: "GET",
      url: ENDPOINT,
    }),
    deleteFromElastic : (elasticIndexName, filter) => {
        let request = {};
          request.tableName = elasticIndexName;
          if (filter) {
            filter.forEach(n => {
              n.columnValue = n.columnValue.toString();
            });
          }
          request.columns = filter;
        
        const headers = {
          'Content-Type': 'application/json',
        };
        
       return axios({
          method: "POST",
          url: ENDPOINT.replace("search",'delete'),
          headers: headers,
          data: request,
        })
    },
    deleteMultiple: (elasticIndexName, filters) => {
      const headers = {
        'Content-Type': 'application/json',
      };
      
     return axios({
        method: "POST",
        url: ENDPOINT.replace("search",'deleteMultiple'),
        headers: headers,
        data: {
          tableName : elasticIndexName,
          columns : filters
        },
      })
    },
    insertMultiple : function (elasticIndexName, requestObj) {
      return axios({
        method: "POST",
        url: ENDPOINT.replace("search",'insertMultiple'),
        headers: {
          "Content-Type": "application/json", 
        },
        data: {
          tableName : elasticIndexName,
          records : requestObj
        },
      });
    },
  fetchReport: (reportName, filters = [],dynamicColumns = []) =>
    axios({
      method: "POST",
      url: ENDPOINT,
      data: {
        elasticQueryName:reportName,
      reportName:reportName,
        filters,
        dynamicColumns
      },
      // 'headers': {
      //     Authorization: token
      // }
    }),
  postMethod: (reportName, requestBody) =>
    axios({
      method: "POST",
      url: ENDPOINT,
      // 'headers': {
      //     Authorization: token
      // },
      data: {
        reportName: reportName,
      },
    }),
  putMethod: (reportingName, requestBody) =>
    fetch(ENDPOINT, {
      method: "PATCH",
      //headers: {    "Content-type": "application/json",  Authorization: token  },
      body: JSON.stringify(requestBody),
    }),
};
